// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Styles
import { SuccessDescriptionBodyStyled } from 'containers/success/success.container.styled';
// Translations
import { WHATS_NEXT_DESCRIPTION } from './translations/success-description-pending.translations';

const SuccessDescriptionPendingComponent = (): React.JSX.Element => (
  <SuccessDescriptionBodyStyled>
    <ParagraphComponent>
      <FormattedMessage id={WHATS_NEXT_DESCRIPTION} />
    </ParagraphComponent>
  </SuccessDescriptionBodyStyled>
);

export { SuccessDescriptionPendingComponent };
